module.exports = __webpack_public_path__ + "img/advanced.2c239be4.svg";